export interface ModuleSession {
  token: string;
  guardiao: Record<string, unknown>;
}

/** A validação de identidade/permissão permanece a cargo da API autenticada. */
export function parseModuleSession(token: unknown, guardiao: unknown): ModuleSession | null {
  if (typeof token !== 'string' || !token.trim()) return null;
  try {
    const user = typeof guardiao === 'string' ? JSON.parse(guardiao) : guardiao;
    if (!user || typeof user !== 'object' || Array.isArray(user)) return null;
    return { token, guardiao: user as Record<string, unknown> };
  } catch {
    return null;
  }
}

export function isTrustedModuleMessage(event: MessageEvent, parent: Window, serverUrl: string): boolean {
  try {
    return event.source === parent && event.origin === new URL(serverUrl).origin;
  } catch {
    return false;
  }
}
